module.exports = __webpack_public_path__ + "static/media/af.017aa03f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/af.png
// module id = 1777
// module chunks = 0